import { 
  BadgeUserPendingCertification, 
  BadgeUserAccountStatus, 
  BadgeUserCertified, 
  ImgUserPicture 
} from '@/components/custom';
import { getPhotoUrl, isCertified, cn, isCertifPending } from '@/lib/utils';
import { UserAccountStatusEnum } from '@/enums';
import UserCardFooter from './UserCardFooter';
import { Card } from '@/components/ui';
import { TProps } from '.';

const UserCard = ({ user, className, onClickBtnSee, onClickBtnDelete }: TProps) => {

  const hasPendingCertification = isCertifPending(user.verifications);
  const hasCertification = isCertified(user.verifications);
  const isInactive = user.accountStatus !== UserAccountStatusEnum.ACTIVE;

  return (
    <Card 
      className={cn(
        'w-full relative overflow-hidden group border-border shadow-xs',
        'animate__animated animate__fadeIn',
        'transition-all duration-300 hover:shadow-md hover:-translate-y-1',
        className
      )}
    >
      <div className="relative w-full aspect-square bg-muted overflow-hidden">
        
        <ImgUserPicture
          enableFullScreen
          role='button'
          alt={'user-image'}
          src={getPhotoUrl(user.photo)} 
          className={cn(
            'w-full h-full object-cover',
            'transition-transform duration-700 ease-out group-hover:scale-110',
            isInactive && 'grayscale opacity-80'
          )}
        />

        <div className="absolute top-2 left-2 z-10">
          <BadgeUserAccountStatus
            user={user}
            title='Compte inactif'
            isVisible={() => isInactive}
            className={cn(
              'shadow-xs text-[10px] uppercase font-bold tracking-wide px-2 py-0.5 rounded-sm',
              user.accountStatus === UserAccountStatusEnum.SUSPENDED
                ? 'bg-amber-500 text-white border border-white/20'
                : 'bg-destructive text-destructive-foreground border border-destructive-foreground/20'
            )}
          />
        </div>

        <div className="absolute top-2 right-2 z-10 flex flex-col items-end gap-1 pointer-events-none">
          {hasCertification && (
            <span className="shadow-xs bg-background/90 backdrop-blur-xs rounded-full p-1 flex items-center justify-center">
              <BadgeUserCertified forceDisplay />
            </span>
          )}
          
          {hasPendingCertification && (
             <span className="shadow-xs bg-background/90 backdrop-blur-xs rounded-full overflow-hidden">
              <BadgeUserPendingCertification 
                forceDisplay={true}
                mode='banner' 
              />
            </span>
          )}
        </div>
        
        <div className="absolute bottom-0 left-0 right-0 h-8 bg-linear-to-t from-black/10 to-transparent pointer-events-none" />
      </div>

      <div className="bg-card border-t border-border">
        <UserCardFooter
          onClickBtnDelete={onClickBtnDelete}
          onClickBtnSee={onClickBtnSee}
          user={user} 
        />
      </div>
    </Card>
  );
};

export default UserCard;